// service/websitePlanService.js
import { postAction } from "./apiHelpers";

const URL = "https://pro.mokshiq.in/website_plan_manager";

/**
 * Matches these curl actions:
 *   action=GET
 *   action=GETBYID&id=...
 *   action=ADDUPDATE&id=...(optional)&plan_name=...&duration=...&one_time_cost=...
 *            &sleep_time_charges=...&daily_increment=...&server_status=...
 *            &status=...&created_by=...
 *   action=DELETE&id=...
 */
export const websitePlanService = {
  getAll: () => postAction(URL, { action: "GET" }),

  getById: (id) => postAction(URL, { action: "GETBYID", id }),

  addOrUpdate: ({
    id,
    plan_name,
    duration,
    one_time_cost,
    sleep_time_charges,
    daily_increment,
    server_status = "true",
    status = "true",
    created_by,
  }) =>
    postAction(URL, {
      action: "ADDUPDATE",
      ...(id ? { id } : {}),
      plan_name,
      duration,
      one_time_cost,
      sleep_time_charges,
      daily_increment,
      server_status,
      status,
      created_by,
    }),

  remove: (id) => postAction(URL, { action: "DELETE", id }),
};

export default websitePlanService;